"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUPPORTED_ENVS = exports.EnvNames = void 0;
const network_1 = require("../network");
var EnvNames;
(function (EnvNames) {
    EnvNames["MainNets"] = "mainnets";
    EnvNames["TestNets"] = "testnets";
    EnvNames["LocalNets"] = "localnets";
})(EnvNames = exports.EnvNames || (exports.EnvNames = {}));
exports.SUPPORTED_ENVS = {
    [EnvNames.MainNets]: {
        apiOptions: {
            host: 'etherspot.pillarproject.io',
            useSsl: true,
        },
        networkOptions: {
            supportedNetworkNames: [
                network_1.NetworkNames.Mainnet,
                network_1.NetworkNames.Xdai,
                network_1.NetworkNames.Bsc,
                network_1.NetworkNames.Fantom,
                network_1.NetworkNames.Matic,
                network_1.NetworkNames.Aurora,
                network_1.NetworkNames.Avalanche,
            ],
        },
    },
    [EnvNames.TestNets]: {
        apiOptions: {
            host: 'qa-etherspot.pillarproject.io',
            useSsl: true,
        },
        networkOptions: {
            supportedNetworkNames: [
                network_1.NetworkNames.Ropsten,
                network_1.NetworkNames.Rinkeby,
                network_1.NetworkNames.Goerli,
                network_1.NetworkNames.Kovan,
                network_1.NetworkNames.Sokol,
                network_1.NetworkNames.BscTest,
                network_1.NetworkNames.FantomTest,
                network_1.NetworkNames.Mumbai,
                network_1.NetworkNames.AuroraTest,
                network_1.NetworkNames.Fuji,
                network_1.NetworkNames.Etherspot,
            ],
        },
    },
    [EnvNames.LocalNets]: {
        apiOptions: {
            host: 'localhost',
            port: 4000,
        },
        networkOptions: {
            supportedNetworkNames: [
                network_1.NetworkNames.LocalA,
                network_1.NetworkNames.LocalB,
                network_1.NetworkNames.LocalH,
            ],
        },
    },
};
